import { useEffect, useState } from 'react';
import { employesApi } from '../../api/resources';
import { Bar } from '../../components/ui/Bar.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { ListeDocuments } from '../../components/ListeDocuments.jsx';
import { C } from '../../theme/palette';

/**
 * Lettres et certificats d'un employé, côté direction.
 *
 * <p>« Il faut que je puisse voir sa démission en PDF. » La démission n'était
 * qu'un message dans le fil ; elle est ici, avec la lettre de résiliation et
 * les certificats, chacun en PDF tel qu'il a été figé.
 *
 * @param {object} props propriétés
 * @param {number} props.empId employé
 * @returns {JSX.Element|null} la carte, rien tant que l'employé n'est pas enregistré
 */
export function DocumentsEmploye({ empId }) {
  const [documents, setDocuments] = useState([]);
  useEffect(() => {
    if (!Number.isInteger(empId)) return undefined;
    let actif = true;
    Promise.resolve()
      .then(() => employesApi.documents(empId))
      .then((liste) => {
        if (actif) setDocuments(Array.isArray(liste) ? liste : []);
      })
      .catch(() => {
        if (actif) setDocuments([]);
      });
    return () => {
      actif = false;
    };
  }, [empId]);
  if (!Number.isInteger(empId)) return null;
  return (
    <Card style={{ marginTop: 11 }}>
      <Bar
        icon="📂"
        title="Documents"
        color={C.navy}
        sub="Démission, lettre de résiliation, certificats"
      />
      <div style={{ padding: 13 }}>
        <ListeDocuments
          documents={documents}
          cheminDe={(id) => `/employes/${empId}/documents/${id}`}
          vide="Aucune lettre ni certificat pour l’instant. La démission remise par l’employé, ta lettre de résiliation et ses certificats apparaissent ici."
          titre="📂 Lettres et certificats"
        />
      </div>
    </Card>
  );
}
